/**
 * TermsUpdateBanner — non-blocking notice that the user is on an outdated
 * Terms of Service version.
 *
 * This replaces the legacy TermsModal interstitial. It only renders when the
 * user has already completed onboarding so a brand-new signup never sees a
 * ToS prompt on the same page load as the wizard handoff.
 */

import { useQuery } from '@tanstack/react-query'
import { Link } from 'react-router-dom'
import { CURRENT_TERMS_VERSION } from '@spoofio/shared'
import { api } from '@/services/api'

export function TermsUpdateBanner() {
  const { data: profile } = useQuery({
    queryKey: ['user-profile'],
    queryFn: () => api.getUserProfile(),
  })

  if (!profile) return null
  if (!profile.onboardingCompletedAt) return null
  if (profile.termsVersion === CURRENT_TERMS_VERSION) return null

  return (
    <div
      role="status"
      className="rounded-md border border-warning-200 bg-warning-50 px-4 py-3 text-sm text-warning-800 flex items-center justify-between"
    >
      <span>
        We&apos;ve updated our Terms of Service. Please review and accept the
        latest version.
      </span>
      <Link
        to="/profile"
        className="font-medium text-warning-900 underline hover:no-underline"
      >
        Review Terms
      </Link>
    </div>
  )
}
